module.exports = __webpack_public_path__ + "webfonts/398F09_0_0.woff";


//////////////////
// WEBPACK FOOTER
// ./src/webfonts/398F09_0_0.woff
// module id = 56
// module chunks = 0